import * as React from 'react';
import PropTypes from 'prop-types';

class ResetGameButton extends React.Component {
    constructor(props) {
        super(props);

        this.handleClick = this.handleClick.bind(this);
    }

    handleClick() {
        if (window.confirm('Esti sigur ca vrei sa resetezi jocul ?')) {
            this.props.onClick();
        }
    }

    render() {
        return (
            <button
                className="btn btn-danger float-left"
                onClick={ this.handleClick }
            >
                Reseteaza jocul
            </button>
        );
    }
}

ResetGameButton.propTypes = {
    onClick: PropTypes.func.isRequired,
};

export default ResetGameButton;



// WEBPACK FOOTER //
// ./src/components/ResetGameButton.js